import "./styles.css";
import React, { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import axios from "axios";
import { Topo } from "../Topo";
import { LoadingSpinner } from "../loading";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { Resultados } from "../Resultados";
import FiltrosPesquisa from "../FiltrosPesquisa";
import { SelectOrdem } from "../SelectOrdem";

export default function LegislacaoComFiltro() {
  useEffect(() => {
    localStorage.setItem("visualizacao", "pesquisa");
  }, []);

  const [page, setPage] = useState(0);
  const [searchPageClicked, setSearchPageClicked] = useState(false); // Flag para indicar se o botão de pesquisa foi clicado
  const [result, setResult] = useState({});
  const [highlighting, setHighlighting] = useState({});
  const [loading, setLoading] = useState(false);
  const [numFound, setNumFound] = useState(null);
  const [searchOrdem, setSearchOrdem] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedTipos, setSelectedTipos] = useState([]);
  const [searchSituacao, setSituacao] = useState([]);
  const [selectedAno, setSelectedAno] = useState([]);
  const [selectedNumber, setSelectedNumber] = useState(0);
  const [selectedInitialDate, setSelectedInitialDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [selectedAssuntos, setSelectedAssuntos] = useState([]);
  const inputRef = useRef(null);
  const ordemRef = useRef(null);
  const api = `${process.env.REACT_APP_API_BASE_URL}/buscar?`;
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const handleCloseMobileMenu = () => setShowMobileMenu(false);
  const handleShowMobileMenu = () => setShowMobileMenu(true);
  const [selectedOrdemOption, setSelectedOrdemOption] = useState(null);

  const options = [
    {
      value: "&ordenar_por=",
      label: "Relevância"
    },
    {
      value: "&ordenar_por=ano%20desc,numero%20desc",
      label: "Número decrescente",
    },
    {
      value: "&ordenar_por=ano%20asc,numero%20asc",
      label: "Número crescente"
    },
    {
      value: "&ordenar_por=data_publicacao%20desc",
      label: "Publicação decrescente",
    },
    {
      value: "&ordenar_por=data_publicacao%20asc",
      label: "Publicação crescente",
    }
  ];

  const filtrosPesquisaRef = useRef(null);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch(); // Chama a função de pesquisa quando a tecla Enter for pressionada
    }
  };

  const origens = selectedOptions
    .map((option) => `&origem[]=${option.value}`)
    .join("");
  const tipos = selectedTipos
    .map((option) => `&tipo[]=${option.value}`)
    .join("");
  const assuntos = selectedAssuntos
    .map((option) => `&assunto[]=${option.value}`)
    .join("");
  const situacao = searchSituacao
    .map((option) => `&situacao[]=${option.value}`)
    .join("");
  const number = selectedNumber !== 0 ? `&numero_ini=${selectedNumber}` : "";
  const numberFim = selectedNumber !== 0 ? `&numero_fim=${selectedNumber}` : "";
  const ano = selectedAno.map((option) => `&ano[]=${option.value}`).join("");
  const dataInicial = selectedInitialDate
    ? `&data_publicacao_ini=${selectedInitialDate.toLocaleDateString()}`
    : "";
  const dataFinal = selectedEndDate
    ? `&data_publicacao_fim=${selectedEndDate.toLocaleDateString()}`
    : "";

  const handleClear = () => {
    setSearchText("");
    setSelectedInitialDate(null);
    setSelectedEndDate(null);
    setSelectedNumber(0);
    setSelectedAssuntos([]);
    setSituacao([]);
    setSelectedOptions([]);
    setSelectedTipos([]);
    setSelectedAno([]);
    setNumFound(null);
    setResult({});
    setSearchOrdem("");
    setSelectedOrdemOption(null);

    if (filtrosPesquisaRef.current) {
      filtrosPesquisaRef.current.clear();
    }
  };

  const handleNumberSelect = (selectedNumber) => {
    setSelectedNumber(selectedNumber);
  };

  const handleSelectionChange = (selected) => {
    setSelectedOptions(selected);
  };

  const handleSelectionTiposChange = (selected) => {
    setSelectedTipos(selected);
  };

  const handleSelectionAssuntosChange = (selected) => {
    setSelectedAssuntos(selected);
  };

  const handleSelectionAnoChange = (selected) => {
    setSelectedAno(selected);
  };

  const handleSelectionSituacaoChange = (selected) => {
    setSituacao(selected);
  };

  const handleInitialDateChange = (date) => {
    setSelectedInitialDate(date);
  };

  const handleEndDateChange = (date) => {
    setSelectedEndDate(date);
  };

  const handleSelectionOrdemChange = (selected) => {
    setSearchOrdem(selected.value);
    setSelectedOrdemOption(selected);
    setSearchPageClicked(true);
  };

  const handlePageSelected = (pageNumber) => {
    setPage(pageNumber);
    setSearchPageClicked(true);
  };

  const handleSearch = () => {
    setPage(1);

    if(searchText.trim() === '' && searchOrdem === ''){
      setSearchOrdem(options[1].value);
      setSelectedOrdemOption(options[1]);
    }
    
    setSearchPageClicked(true);
  };

  const handleFiltro = () => {
    handleCloseMobileMenu();
    handleSearch();    
  };

  const filtrosDePesquisa = (
    <FiltrosPesquisa
      ref={filtrosPesquisaRef}
      loading={loading}
      handleSelectionChange={handleSelectionChange}
      handleSelectionTiposChange={handleSelectionTiposChange}
      handleSelectionAssuntosChange={handleSelectionAssuntosChange}
      handleNumberSelect={handleNumberSelect}
      handleSelectionAnoChange={handleSelectionAnoChange}
      handleSelectionSituacaoChange={handleSelectionSituacaoChange}
      handleInitialDateChange={handleInitialDateChange}
      handleEndDateChange={handleEndDateChange}
      handleFiltro={handleFiltro}
      selectedNumber={selectedNumber}
      selectedInitialDate={selectedInitialDate}
      selectedEndDate={selectedEndDate}
    />
  );

  const fetchData = () => {
    const pageNumber = page === 0 ? 1 : page;

    const searchTextNoSlash = searchText.replace(/\//g, ' ');

    const url = `${api}q=${searchTextNoSlash}${searchOrdem}${origens}${tipos}${ano}${assuntos}${dataInicial}${dataFinal}${number}${numberFim}&page=${pageNumber}${situacao}`;

    axios
      .get(url)
      .then((response) => {
        const resultados = response.data.response;
        setResult(resultados);
        setNumFound(resultados?.numFound);
        setHighlighting(response.data.highlighting);

        const ids = resultados.docs.map((resultado) => resultado.id);

        const requisicoes = ids.map(
          (id, index) =>
            new Promise((resolve, reject) => {
              setTimeout(() => {
                axios
                  .get(
                    `${process.env.REACT_APP_API_BASE_URL}/listar-relacionados?id=${id}`,
                    { timeout: 10000 }
                  )
                  .then((resposta) => {
                    resolve(resposta.data);
                  })
                  .catch((error) => {
                    reject(error);
                  });
              }, index * 10);
            })
        );

        Promise.all(requisicoes)
          .then((respostas) => {
            const resultadosAtualizados = resultados.docs.map(
              (resultado, index) => ({
                ...resultado,
                relacionados: respostas[index],
              })
            );

            const resultadosComNumFound = {
              ...resultados,
              docs: resultadosAtualizados,
            };
            setResult(resultadosComNumFound);
          })
          .catch((error) => {
            console.error(error);
          });
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    if(searchPageClicked){
      setLoading(true);
      fetchData();
      setSearchPageClicked(false);
    }
    
  }, [page, searchOrdem, searchPageClicked]);

  const [expandedItems, setExpandedItems] = useState({});

  const toggleExpanded = (relacionadoId) => {
    setExpandedItems((prevState) => ({
      ...prevState,
      [relacionadoId]: !prevState[relacionadoId],
    }));
  };

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  const getHighlightContent = (id) => {
    try {
      if (highlighting[id]) {
        if (
          highlighting[id].content_copy &&
          highlighting[id].content_copy.length > 0
        ) {
          return highlighting[id].content_copy;
        } else if (
          highlighting[id].content &&
          highlighting[id].content.length > 0
        ) {
          return highlighting[id].content;
        }
      }
    } catch (error) {
      return null;
    }
    return null;
  };

  useEffect(() => {
    const handleScrollToTop = () => {
      window.scrollTo(0, 0);
    };

    if (loading) {
      handleScrollToTop();
    }

    handleScrollToTop();
  }, [loading]);

  return (
    <div>
      <div className="App">{/* <div className="Sidebar"> */}</div>
      <div className="bg-topo grey-border-bottom">
        <Topo
          handleCloseMobileMenu={handleCloseMobileMenu}
          handleShowMobileMenu={handleShowMobileMenu}
          showMobileMenu={showMobileMenu}
          SideBarMenu={filtrosDePesquisa}
          modo={"pesquisa"}
        />
      </div>
      <Container fluid className="main-container">
        <Row className="grey-border-bottom">
          <Col>
            <div className={`d-flex justify-content-center mb-4 mt-4`}>
              <div className={`bar-pesquisa`}>
                <Form.Control
                  placeholder="Termos de pesquisa"
                  value={searchText}
                  onKeyPress={handleKeyPress}
                  onChange={(e) => setSearchText(e.target.value)}
                  className={`me-1`}
                  ref={inputRef} // Set the reference to the input
                />
                <Button
                  variant="primary"
                  onClick={handleSearch}
                  disabled={loading}
                  className={`me-1`}
                >
                  Pesquisar
                </Button>
                <Button
                  variant="secondary"
                  onClick={handleClear}
                  disabled={loading}
                >
                  Limpar
                </Button>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            xl={3}
            lg={3}
            md={3}
            className="sidebar grey-border-right d-none d-md-block"
          >
            <h2 className="secao">
              <FontAwesomeIcon icon={faFilter} /> Filtros de Pesquisa
            </h2>
            {filtrosDePesquisa}
          </Col>
          <Col xl={9} lg={9} md={9} sm={12} className="resultados">
            <Row>
              {!loading && numFound > 0 && (
                <div
                  className={`d-flex justify-content-between align-items-center mt-2 mb-2 fs-8`}
                >
                  <div>Resultados encontrados: {numFound}</div>
                  <div
                    className={`d-flex justify-content-end align-items-center`}
                  >
                    Ordenar por:&nbsp;
                    <SelectOrdem onChange={handleSelectionOrdemChange} options={options} selectedOption={selectedOrdemOption} ref={ordemRef} />
                  </div>
                </div>
              )}
            </Row>
            {loading ? (
              <span className="d-flex justify-content-center">
                <LoadingSpinner />
              </span>
            ) : (
              <Resultados
                result={result}
                getHighlightContent={getHighlightContent}
                toggleExpanded={toggleExpanded}
                expandedItems={expandedItems}
                page={page}
                handlePageSelected={handlePageSelected}
              />
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
